import React from "react";
import ActionsKanban from "src/pages/Actions/Kanban";
import ActionsPanel from "src/pages/Actions/Panel";
import PrioritizationMatrix from "src/pages/Actions/PrioritizationMatrix";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/actions/panel" key="actionspanel" exact component={ActionsPanel} isPrivate/>,
	<RoutePrivate path="/actions/panel/:actionId" permissionPath="/actions/panel" key="actionspanelActionId" exact component={ActionsPanel} isPrivate/>,
	<RoutePrivate path="/actions/kanban" key="actionskanban" exact component={ActionsKanban} isPrivate/>,
	<RoutePrivate path="/actions/kanban/:kanbanId" permissionPath="/actions/kanban" key="actionsKanbanGrouperId" exact component={ActionsKanban} isPrivate/>,
	<RoutePrivate path="/actions/matrix" key="actionsmatrix" exact component={PrioritizationMatrix} isPrivate/>,
	<RoutePrivate path="/actions/matrix/:responsible" key="actionsmatrixWithFilter" permissionPath="/actions/matrix" exact component={PrioritizationMatrix} isPrivate/>
];
